import { render, staticRenderFns } from "./PostsListPlanned.vue?vue&type=template&id=742c47ce&scoped=true&"
import script from "./PostsListPlanned.vue?vue&type=script&lang=js&"
export * from "./PostsListPlanned.vue?vue&type=script&lang=js&"
import style0 from "./PostsListPlanned.vue?vue&type=style&index=0&id=742c47ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c47ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
